import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import _ from "underscore";

var OrgDropdown = require("components/org/OrgDropdown");
var BraveCheckbox = require("components/utility/BraveCheckbox");
var BraveToolbar = require("components/utility/BraveToolbar");
var Modal = require("components/utility/AltModal");
var Glyphicon = require("components/utility/icons/Glyphicon");
var StandardIcon = require("components/utility/icons/StandardIcon");
var Spinner = require("components/utility/Spinner");

var RosterStudent = require("components/org/roster/RosterStudent");
var RosterUnAssignedStudent = require("components/org/roster/RosterUnAssignedStudent");
var RosterStudentList = require("components/org/roster/RosterStudentList");
var AddRosterClasses = require("components/org/roster/AddRosterClasses");
var AddRosterStudents = require("components/org/roster/AddRosterStudents");
var StudentSubgroups = require("components/org/roster/StudentSubgroups");
var StudentLogins = require("components/org/roster/StudentLogins");
var SchoolInfoModal = require("components/org/roster/SchoolInfoModal");
var AwardCoins = require("components/org/roster/AwardCoins");
var SendNote = require("components/org/roster/SendNote");
var RosterEditStudentLists = require("components/org/roster/RosterEditStudentLists");
var LogReadingModal = require("components/reading/books/LogReadingModal")
var OverdrawnAccountNotice = require("components/users/teachers/upgrade/OverdrawnAccountNotice");
var PendingTaskNotice = require("components/layout/PendingTaskNotice");

var OrgTypes = require("lib/academic/OrgTypes");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var CurrentUser = require("lib/account/CurrentUser");

require("org/roster/roster_content.scss");

@connect(
	(state, props) => {

		// MOUNT STUDENT WITHIN STUDENT LISTS
		var studentLists = {}
		_.each(RosterSelectors.studentListsByAdminId({ state, adminId: CurrentUser.get().id }), (sl) => {
			studentLists[sl.id] = sl
			studentLists[sl.id].students = []
			studentLists[sl.id].primary_students = []
		})

		_.each(state.students, (student) => {
			if (student.student_list_ids) {
				_.each(student.student_list_ids.all, (id) =>{
					if (studentLists[id]) {
						studentLists[id].students.push(student)
					}
				})
				if (studentLists[student.student_list_ids.primary]) {
					studentLists[student.student_list_ids.primary].primary_students.push(student)
				}
			}
		})

		var loading = RosterSelectors.isLoadingStudentLists({ state })

		return {
			currentAdmin: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
			studentLists: _.values(studentLists),
			loading,
			getStudents: (orgIdentifier) => {
				return RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier: orgIdentifier })
			}
		}
	},

	(dispatch, props) => {

		var fetchStudents = function() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS
			return dispatch(RosterActions.fetchStudents({ embeds }));
		}

		var fetchStudentLists = function() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS
			return dispatch(RosterActions.fetchStudentLists({ embeds }));
		}

		var getCleverUser = function() {
			return dispatch(RosterActions.fetchAdmins({
				filters: { ids: [CurrentUser.get().id] },
				embeds: ["admin.clever_user"]
			}))
		}

		var addDemoStudent = function(adminID, studentListID) {
			return dispatch(RosterActions.updateAdmin({
				id: adminID,
				update: { add_demo_for_teacher: true, student_list_id: studentListID }
			}))
		}

		var archiveStudentList =  function(slID) {
			return dispatch(RosterActions.archiveStudentList({
				id: slID
			}));
		}

		var destroyStudents =  function(studentIDs) {
			return dispatch(RosterActions.destroyStudents({
				studentIDs,
				embeds: ["student.student_list_ids"]
			}))
		}

		var updateStudentList =  function(id,update){
			const promises = [];
			if (!_.isEmpty(update)) {
				promises.push(dispatch(RosterActions.updateStudentList({
					id: id, update
				})));
			}
			return Promise.all(promises);
		}

		var fetchArchivedStudentLists = function() {
			var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id

			var query = {
				inactive: true,
				inactive_within_year: true,
				effective_user_id: effectiveUserID,
				embed: ["student_list.primary_students", "student.avatar", "student.student_list_ids", "student.primary_student_list_id"]
			}

			return dispatch(RosterActions.fetchStudentListsStoreless({ query }))
		}


		var populateData = function() {
			return Promise.all([
				fetchStudentLists().then( slResponse => {
					return fetchStudents()
				})
			])
		}

		return {
			fetchStudents,
			fetchStudentLists,
			getCleverUser,
			addDemoStudent,
			archiveStudentList,
			destroyStudents,
			fetchArchivedStudentLists,
			updateStudentList,
			populateData
		}
	}
)

class RosterContent extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		
		// if expand param present, expand those sls
		// if only one sl exist, expand it by default
		var initExpandedSLSections = []
		if ($wr.getURLParameterByName('expand_sl')) {
			var initExpandedSLSections = _.map($wr.getURLParameterByName('expand_sl').split(','), (id) => { return parseInt(id) })
		} else if (_.size(props.studentLists) === 1) {
			var initExpandedSLSections = [_.first(props.studentLists).id]
		}

		this.state = {
			selectedStudentIDs: [],
			clickedStudentListID: null, // Only for default manual add students

			// Modals that are opened by state :(
			logReadingModalOpen: false,

			// Tracks opened student list sections
			expandedStudentListSections: initExpandedSLSections,

			// Tracks status of edit SL form
			expandedStudentListForms: [],
			expandedStudentListFormClass: null,

			demoStudentLoading: false,
			unassignedStudentLists: []
		}

		this.addClassesModal = React.createRef();
		this.addStudentsModal = React.createRef();

		this.subgroupsModal = React.createRef();
		this.awardCoinsModal = React.createRef();
		this.sendNoteModal = React.createRef();
		this.studentLoginsModal = React.createRef();

		this.editStudentListsModal = React.createRef();
		this.deleteStudentModal = React.createRef();
	}

	///////// HELPER METHODS /////////
	maxStudentListCount() {
		return CurrentUser.get().account.max_student_list_count
	}
	maxStudentCount() {
		return CurrentUser.get().account.max_students_count
	}
	isOverdrawnStudentLists() {
		return this.props.studentLists.length > this.maxStudentListCount();
	}
	isOverdrawnStudents() {
		return _.filter(this.props.studentLists, (studentList) => {
			if (studentList.students) {
				return studentList.students.length > this.maxStudentCount()
			}
		}).length > 0;
	}

	isAdmin() {
		return CurrentUser.isSchoolAdmin() || CurrentUser.isDistrictAdmin()
	}

	isRosterDisabled() {
		if (this.props.studentLists.length > 0) {
			const prefs = this.props.studentLists[0].prefs
			if (prefs && prefs["rostering_method"] && !_.isEmpty(prefs["rostering_method"]) && prefs["rostering_method"]["manager"] != "individual") {
				return true
			}
		}

		return false //this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false
	}

	hasCleverUser() {
		return this.props.currentAdmin && this.props.currentAdmin.clever_user
	}

	// used to tell if we should display button.
	slHasNonPrimaryStudents(studentList){
		return _.some(studentList.students, (student) => {
			return (student.student_list_ids.primary != studentList.id)
		})
	}

	hasMismatchedGradeLevels(studentList){
		return _.some(studentList.students, (student)=>{
			return student.prefs.academic_level.toString() != studentList.grade_level
		})
	}

	isAddingClassDisabled() {
		if (this.props.studentLists.length > 0) {
			const prefs = this.props.studentLists[0].prefs
			if (prefs && prefs["rostering_method"] && !_.isEmpty(prefs["rostering_method"])) {
				// DISABLE ADDING CLASS FOR USERS THAT SHOULD SYNC WITH CLEVER OR GOOGLE SSO
				if (prefs["rostering_method"]["manager"] != "individual" || prefs["rostering_method"]["method"] != "manual") {
					return true
				}
			}
		}

		return false
	}

	checkIsPendingSchool() {
		if (this.props.studentLists && this.props.studentLists.length > 0) {
			var schools = _.pluck(this.props.studentLists, 'school')
			if (!schools) {
				return true
			}

			var pendingSchools = _.where(schools, { zip: "00000" })
			if (_.size(pendingSchools) == _.size(schools)) {
				return true
			}
		}
		return false
	}

	getStudentListIDs() {
		return _.map(this.props.studentLists, sl => { return sl.id })
	}

	unassignedStudents() {
		return _.where(_.flatten(_.pluck(this.state.unassignedStudentLists, 'primary_students')), { suspended: false })
	}

	unassignedSLLookup(student) {
		return _.first(_.filter(this.state.unassignedStudentLists, (sl) => {
			return _.contains(_.pluck(sl.students, 'id'), student.id)
		}))
	}

	///////// STUDENT GETTERS /////////

	filteredStudents(studentListID) {
		if (this.props.orgIdentifier.includes(OrgTypes.SUBGROUP)) {
			var allStudents = this.props.getStudents(OrgTypes.toIdentifier({
				type: OrgTypes.SUBGROUP, key: this.props.orgIdentifier.replace('subgroup:', '')
			}));

			return _.filter(allStudents, (stu) => { return _.includes(stu.student_list_ids.all, studentListID) })
		}
		return this.props.getStudents(OrgTypes.toIdentifier({
			type: OrgTypes.STUDENT_LIST, key: studentListID
		}));
	}

	filteredStudentLists() {
		if (this.props.orgIdentifier.includes(OrgTypes.SUBGROUP)) {
			var students = this.props.getStudents(OrgTypes.toIdentifier({
				type: OrgTypes.SUBGROUP, key: this.props.orgIdentifier.replace('subgroup:', '')
			}));

			var slIDs = _.uniq(_.flatten(_.pluck(_.pluck(students, 'student_list_ids'), 'all')))

			return _.filter(this.props.studentLists, (sl) => { return _.includes(slIDs, sl.id) })
		}
	}

	allStudents() {
		if (this.props.studentLists.length) {
			return _.uniq(_.flatten(
				this.props.studentLists.map(sl => this.filteredStudents(sl.id))
			));
		}
	}


	allSelectedStudents() {
		var students = this.allStudents()
		if (students && students.length > 0 ) {
			return this.allStudents().filter(s => this.isSelectedStudentID(s.id));	
		}
		return []
	}

	///////// STUDENT SETTERS /////////

	afterStudentCreate() {
		if (this.addDemoStudentModal.current) {
			this.addDemoStudentModal.current.hide();
		}
		this.props.fetchStudentLists()
		this.props.fetchStudents()
	}

	handleMultipleStudentDestroy(e) {
		$wr.nope(e);
		if (confirm("Are you sure you want to delete all selected students? Students will be removed from all classes.")) {
			this.props.destroyStudents(this.state.selectedStudentIDs).then(() => {
				var bannerTitle = `${_.size(this.state.selectedStudentIDs)} Students Deleted`
				this.setState({ selectedStudentIDs: [] })
				window.wrNotifications.triggerDropDownNotification({
					title: bannerTitle, icon: "ok-sign"
				}, 4000);
			}).catch(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Oops!", text: "Something went wrong and the students were not deleted",
					type: "error", icon: "remove"
				}, 4000);
			})
		}
	}

	updateArchivedStudentLists() {
		this.props.fetchArchivedStudentLists().then((response) => {
			if (response.student_lists) {
				this.setState({ unassignedStudentLists: response.student_lists })
			}
		})
	}

	onUpdateArchivedStudent() {
		this.updateArchivedStudentLists()
		this.props.fetchStudentLists()
		this.props.fetchStudents()
	}

	///////// STUDENT LIST EXPANSION /////////

	handleExpandStudentListSection(slID) {
		if (this.slExpanded(slID)) {
			this.setState({ expandedStudentListSections: _.without(this.state.expandedStudentListSections, slID), expandedStudentListForms: _.without(this.state.expandedStudentListForms, slID) })
		} else {
			this.setState({ expandedStudentListSections: [...this.state.expandedStudentListSections, slID] })
		}
	}

	slExpanded(slID) {
		return _.includes(this.state.expandedStudentListSections, slID)
	}

	slFormExpanded(slID) {
		return _.includes(this.state.expandedStudentListForms, slID)
	}

	allExpanded() {
		return _.size(this.props.studentLists) == _.size(this.state.expandedStudentListSections)
	}

	toggleAllStudentLists() {
		var expandedSLs = this.allExpanded() ? [] : this.getStudentListIDs()
		this.setState({ expandedStudentListSections: expandedSLs })
	}

	///////// STUDENT LIST FORM EXPANSION /////////

	// Shows and hides edit student list form
	toggleEditSLForm(slID) {
		if (_.includes(this.state.expandedStudentListForms, slID)) {
			this.setState({ expandedStudentListFormClass: 'drawerClosed' }, () => {
				// keep this setTimeout function to ensure all 
				// transitions are complete before removing
				setTimeout(function () {
					this.setState({ expandedStudentListForms: _.without(this.state.expandedStudentListForms, slID) })
				}.bind(this), 1500);
			});
		} else {
			this.setState({ expandedStudentListForms: [...this.state.expandedStudentListForms, slID] }, () => {
				setTimeout(function () {
					this.setState({ expandedStudentListFormClass: 'drawerOpen' });
				}.bind(this), 50);
			});
		}
	}

	///////// STUDENT LIST MANIPULATORS /////////

	onArchive(slID) {
		if (confirm('Are you sure you want to delete this class? This will also delete students who are ONLY in this class. This will NOT delete any students who are in multiple classes.')) {
			this.props.archiveStudentList(slID)
			var title = "Class Archived"
			var text = "You have archived this class. However, no class is left behind."

			window.wrNotifications.triggerDropDownNotification({
				title: title, text: text, icon: "ok-circle"
			}, 4000);
		}
	}

	// makes studentList the primary sl for all of its students
	onForcePrimary(studentList, e){
		$wr.nope(e)
		this.props.updateStudentList(studentList.id, {"force_primary": true}).then(res=>{
			this.props.fetchStudentLists()
			this.props.fetchStudents()
		})
	}

	onForceGradeLevel(studentList, e){
		$wr.nope(e)
		this.props.updateStudentList(studentList.id, {"force_grade_level": true}).then(res=>{
			this.props.fetchStudentLists()
			this.props.fetchStudents()
		})
	}

	// adds student list after creation
	addStudentLists() {
		this.addClassesModal.current.hide();
		this.props.fetchStudentLists();
	}

	handleRosterUpdate(event, taskName) {
		if ($wr.getURLParameterByName('expand_sl')) {
			var studentListIDs = _.map($wr.getURLParameterByName('expand_sl').split(','), (id) => { return parseInt(id) })
			this.setState({ expandedStudentListSections: [...this.state.expandedStudentListSections, ...studentListIDs] })
		}

		if ((taskName == PendingTaskNotice.UPLOADING_STUDENTS) ||
			(taskName == PendingTaskNotice.CLEVER_SYNC) ||
			(taskName == PendingTaskNotice.GOOGLE_SYNC) ||
			(taskName == undefined)) {
			if (this.addStudentsModal.current) {
				this.addStudentsModal.current.hide();
			}
			// reload data needed since PendingTaskNotice doesn't use redux
			this.props.fetchStudentLists()
			this.props.fetchStudents()
		}
	}

	///////// STUDENT CHECKBOX METHODS /////////

	isSelectedStudentID(studentID) {
		return !!_.contains(this.state.selectedStudentIDs, studentID);
	}

	isSelectedStudentListID(studentListID) {
		var students = this.filteredStudents(studentListID);
		return !!(students.length && _.all(students, (s) => this.isSelectedStudentID(s.id)));
	}

	isAllStudentsSelected() {
		var studentIDs = _.pluck(this.allStudents(), "id");
		return _.difference(studentIDs, this.state.selectedStudentIDs).length === 0;
	}

	toggleStudentID(studentID) {
		if (this.isSelectedStudentID(studentID)) {
			var selectedStudentIDs = _.difference(this.state.selectedStudentIDs, [studentID]);
		} else {
			var selectedStudentIDs = _.uniq(this.state.selectedStudentIDs.concat([studentID]));
		}
		this.setState({ selectedStudentIDs });
	}

	toggleStudentListID(studentListID) {
		var studentIDs = _.pluck(this.filteredStudents(studentListID), "id");
		if (this.isSelectedStudentListID(studentListID)) {
			var selectedStudentIDs = _.difference(this.state.selectedStudentIDs, studentIDs);
		} else {
			var selectedStudentIDs = _.uniq(this.state.selectedStudentIDs.concat(studentIDs));
		}
		this.setState({ selectedStudentIDs });
	}

	toggleAll() {
		if (this.isAllStudentsSelected()) {
			var selectedStudentIDs = [];
		} else {
			var selectedStudentIDs = _.pluck(this.allStudents(), "id");
		}
		this.setState({ selectedStudentIDs });
	}

	deselectedAll() {
		this.setState({ selectedStudentIDs: [] });
	}

	///////// MODALS /////////

	openAddStudentModal(studentListID) {
		this.setState({
			clickedStudentListID: studentListID
		})
		this.addStudentsModal.current.show();
	}

	addDemoStudent(studentListID) {
		this.setState({ clickedStudentListID: studentListID, demoStudentLoading: true })
		this.props.addDemoStudent(CurrentUser.get().id, studentListID).then(() => {
			
			// we need to fetch the students since our action edits the admin
			this.props.fetchStudents().then(() => {
				this.setState({ demoStudentLoading: false })
				window.wrNotifications.triggerDropDownNotification({
					title: "Demo Student Added", text: '', icon: "ok-circle"
				}, 4000);
			})
		})
	}

	///////// RENDER METHODS /////////

	renderOverdrawnMessage() {
		if (this.props.studentLists) {
			if (CurrentUser.isTeacherAdmin() && (this.isOverdrawnStudents() || this.isOverdrawnStudentLists())) {
				if (this.isOverdrawnStudentLists()) {
					var overdrawnAlert = (
						<div className="overdrawnAlert classLimit">
							Over Limit: {this.props.studentLists.length}/{this.maxStudentListCount()} classes
						</div>
					);
				}

				return (
					<div>
						<OverdrawnAccountNotice source="roster" />
						{overdrawnAlert}
					</div>
				);
			}
		}
	}

	renderToolbar() {
		var selectedStudents = this.allSelectedStudents();
		var maybe = (openF) => {
			return () => {
				if (_.isEmpty(selectedStudents)) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Select Students", text: "Please select one or more students first.",
						icon: "remove-sign"
					}, 4000
					);
					return;
				}
				openF();
			}
		}
		
		return (
			<div className='toolbarContainer'>
					<BraveToolbar itemCount={selectedStudents.length}
					icon="student" iconType={StandardIcon.WR_ICON}
					onClear={this.deselectedAll} >
					<div className="rowOne">
						<button className="btn btn-link"
							onClick={maybe(() => this.subgroupsModal.current.show())}>
							{this.renderGroupLinkText()}
						</button>
						<button className="btn btn-link"
							onClick={maybe(() => this.setState({ logReadingModalOpen: true }))}>
							Log Reading
						</button>
						<button className="btn btn-link"
							onClick={maybe(() => this.awardCoinsModal.current.show())}>
							Award Coins
						</button>
						<button className="btn btn-link"
							onClick={maybe(() => this.sendNoteModal.current.show())}>
							Send Note
						</button>
						<button className="btn btn-link"
							onClick={maybe(() => this.editStudentListsModal.current.show())}>
							Edit Classes
						</button>
						<button className="btn btn-link"
							onClick={maybe(() => this.handleMultipleStudentDestroy())}>
							Delete Students
						</button>
						{!this.isAddingClassDisabled() && (
							<button className="btn btn-link"
								onClick={() => this.studentLoginsModal.current.show()}>
								Login Information
							</button>
						)}
					</div>
				</BraveToolbar>

				<Modal ref={this.subgroupsModal} headerText="Student Groups">
					<StudentSubgroups students={selectedStudents}
						onComplete={() => this.subgroupsModal.current.hide()} />
				</Modal>

				<LogReadingModal open={this.state.logReadingModalOpen}
					onClose={() => this.setState({ logReadingModalOpen: false })}
					studentsSelected={selectedStudents} />

				<Modal ref={this.awardCoinsModal} headerText="AwardCoins">
					<AwardCoins students={selectedStudents}
						onComplete={() => this.awardCoinsModal.current.hide()} />
				</Modal>

				<Modal ref={this.sendNoteModal} headerText="Send Note">
					<SendNote students={selectedStudents}
						onComplete={() => this.sendNoteModal.current.hide()} />
				</Modal>

				<Modal ref={this.studentLoginsModal} className="wideModal" headerText="Student Groups">
					<StudentLogins students={selectedStudents} />
				</Modal>

				<Modal ref={this.editStudentListsModal} headerText="Edit Classes">
					<RosterEditStudentLists students={selectedStudents} totalStudentCount={_.size(this.allStudents())}
						onComplete={() => this.editStudentListsModal.current.hide()} />
				</Modal>
			</div>
		)
	}

	renderGroupLinkText() {
		var students = this.allSelectedStudents();
		var studentsWithGroups = 0;

		students.map(function (student) {
			if (!_.isEmpty(student.prefs.subgroup)) {
				studentsWithGroups++;
			}
		});

		return students.length > 0 && students.length == studentsWithGroups ? "Edit Group" : "Add To Group"
	}

	renderEmptySection() {
		return <div key='emptySection' className='emptySection'>You have not added any students yet.</div>;
	}

	renderAddClassButton() {
		if (!this.isAdmin() && !this.isRosterDisabled() && !this.isAddingClassDisabled()) {
			return (
				<button className="btn btn-link rowButton"
					onClick={() => this.addClassesModal.current.show()}>
					Add Classes
				</button>
			);
		}
	}

	renderAddClassModal() {
		if (!this.isAdmin() && !this.isRosterDisabled()) {
			return (
				<Modal className="slightlyNarrowModal"
					headerText="Add Classes"
					ref={this.addClassesModal}>
					<AddRosterClasses addStudentLists={this.addStudentLists} />
				</Modal>
			)
		}
	}

	renderExpandAllButton() {
		var btnText = this.allExpanded() ? 'Collapse All' : 'Expand All'
		return (
			<button className="btn btn-link rowButton"
				onClick={() => this.toggleAllStudentLists()}>
				{btnText}
			</button>
		)
	}

	renderAddStudentButton() {
		if (!this.isAdmin() && !this.isRosterDisabled()) {
			return (
				<button className="btn btn-link rowButton"
					onClick={() => this.openAddStudentModal()}>
					Add Students
				</button>
			)
		}
	}

	renderAddStudentsModal() {
		return (
			<Modal className="moreWideModal"
				headerText="Add Students"
				ref={this.addStudentsModal}>
				<AddRosterStudents
					defaultStudentListID={this.state.clickedStudentListID}
					afterCreate={this.handleRosterUpdate}/>
			</Modal>
		)
	}

	renderOverallLine() {
		return (
			<div key='overalLine' className="overallLine" key="overall">
				<div className="overallLineContent">
					<div className="checkboxSection">
						<BraveCheckbox value={this.isAllStudentsSelected()}
							onClick={this.toggleAll} />
					</div>

					<div className="nameSection">
						<strong>All Students</strong>
					</div>
					<div className="detailSection">
						{this.renderExpandAllButton()}
					</div>
					<div className="detailSection double text-right">
						{this.renderAddStudentButton()}
						{this.renderAddClassButton()}
					</div>
					{this.renderAddStudentsModal()}
					{this.renderAddClassModal()}
				</div>
			</div>
		)
	}

	renderStudentsAndStudentLists() {
		var items = []
		var { type, key } = OrgTypes.fromIdentifier(this.props.orgIdentifier);

		if (type == OrgTypes.ALL_STUDENTS) {
			var studentLists = this.props.studentLists;
		} else if (type == OrgTypes.SUBGROUP) {
			var studentLists = this.filteredStudentLists();
		} else {
			var studentLists = _.filter(this.props.studentLists, (sl) => { return sl.id === key })
		}

		studentLists = _.sortBy(studentLists, "name")
		studentLists = _.sortBy(studentLists, (sl) => {
			if (sl.school) {
				return sl.school.name
			}
		})

		studentLists.forEach((studentList, idx) => {
			var classItems = []
			var studentItems = []
			classItems.push(
				<RosterStudentList key={"sl-" + studentList.id}
					slIndex={idx}
					fetchStudents={this.props.fetchStudents}
					toggleFormStatus={this.toggleEditSLForm}
					openSectionClass={this.state.expandedStudentListFormClass}
					expanded={this.slExpanded(studentList.id)}
					formExpanded={this.slFormExpanded(studentList.id)}
					handleExpandStudentListSection={this.handleExpandStudentListSection}
					studentList={studentList} 
					resetStudentLists={this.props.fetchStudentLists}/>
			);

			var students = $wr.sortByName(this.filteredStudents(studentList.id), $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST);

			//////// DISPLY SPINNER IF STUDENTS ARE STILL LOADING
			if (studentList.student_ids && studentList.student_ids.length > 0 && students.length == 0) {
				studentItems = <Spinner key={"spinner-" + studentList.id} scale={1} placeholder={true} className="studentLoadingSpinner" />

			} else {
				_.sortBy(students, (s) => { return s.suspended }).forEach((student, stuIdx) => {
					studentItems.push(
						<RosterStudent key={"sl-" + studentList.id + "-student-" + student.id}
							index={stuIdx}
							slIndex={idx}
							student={student}
							studentList={studentList}
							selected={this.isSelectedStudentID(student.id)}
							toggleSelected={() => this.toggleStudentID(student.id)} />
					);
				})

				// DEFINE DEMO STUDENT ACTION STATUS
				var demoInClass = _.size(_.where(students, { demo_for_teacher: true })) > 0
				if (this.state.demoStudentLoading) {
					var demoStudentButton = <Spinner key='demo-spinner' scale={1} placeholder={true} className="demoBtnSpinner" />
				} else if (!demoInClass) {
					var demoStudentButton = (
						<button key={"demo-btn-" + studentList.id} className="btn btn-link textColorButton"
							onClick={() => this.addDemoStudent(studentList.id)}>
							<Glyphicon icon="plus-sign" /> Add Demo Student
						</button>)
				} else {
					var demoStudentButton = ''
				}

				// DEFINE STUDENT CREATION ACTION (DEMO AND/OR REAL)
				if (!this.isRosterDisabled()) {
					studentItems.push(
						<div className="overallLine" key={"all-students-" + studentList.id}>
							<div className="text-center">
								<button className="btn btn-link textColorButton"
									onClick={() => this.openAddStudentModal(studentList.id)}>
									<Glyphicon icon="plus-sign" /> Add Students
								</button>
								{demoStudentButton}
							</div>
						</div>
					);
				} else if (!demoInClass || this.state.demoStudentLoading) {
					studentItems.push(
						<div className="overallLine" key={"all-students-" + studentList.id}>
							<div className="text-center">
								{demoStudentButton}
							</div>
						</div>
					);
				}

				if (!this.isRosterDisabled() && !this.hasCleverUser()) {
					var archiveBtn = <button key={"archive-btn-" + studentList.id} className="btn btn-link rowButton archiveBtn" onClick={() => this.onArchive(studentList.id)}> Archive Class </button>
				}

				if (this.slHasNonPrimaryStudents(studentList)){
					var forcePrimaryBtn = <button key={"primary-btn-" + studentList.id} onClick={this.onForcePrimary.bind(this, studentList)} className='"btn btn-link rowButton resetSL' data-tip data-for="primary"> Make Primary For All </button>
				}

				if (this.hasMismatchedGradeLevels(studentList)){
					var forceGradeLevelBtn = <button key={"gl-btn-" + studentList.id} onClick={this.onForceGradeLevel.bind(this, studentList)} className='"btn btn-link rowButton resetGL' data-tip data-for="gradeLevel"> Reset Grade Levels </button>
				}

				var menuOptions = (
					<div className="slMenuOptions studentListMultiselect" key={"slMenuOptions-" + studentList.id}>
						<div className="checkboxSection">
							<BraveCheckbox value={this.isSelectedStudentListID(studentList.id)}
								onClick={() => this.toggleStudentListID(studentList.id)} />
						</div>

						<div className="nameSection">
							<strong>Select Class</strong>
						</div>
						<div className="detailSection"></div>
						<div className="detailSection double text-right">
							<button
								className="btn btn-link rowButton editClassBtn"
								id={ `editClassBtn-${idx}` }
								onClick={() => this.toggleEditSLForm(studentList.id)}> Edit Class
							</button>
							{archiveBtn}
							{forcePrimaryBtn}
							{forceGradeLevelBtn}
						</div>
						<ReactTooltip id="gradeLevel">
							This will set the academic and grade level of each student in this class to grade {studentList.grade_level}.
						</ReactTooltip>
						<ReactTooltip id="primary">
							This will set all this student list as the primary student list for all students in this class.
						</ReactTooltip>
					</div>

				)
			}

			// FINAL ASSEMBLY OF STUDENTS LIST AND STUDENT DISPLAYS
			var collapsedClass = _.include(this.state.expandedStudentListSections, studentList.id) ? "expanded" : "collapsed"
			var classSection = (
				<div className={"classSectionContainer " + collapsedClass} key={'classSectionContainer-' + studentList.id}>
					{classItems}
					<div className="studentSectionContainer">
						{menuOptions}
						{studentItems}
					</div>
				</div>
			)
			items.push(classSection)
		})
		return items;
	}

	renderUnassignedStudents() {
		var items = []
		if (!_.isEmpty(this.state.unassignedStudentLists)) {
			var students = this.unassignedStudents()
			if (_.isEmpty(students)) { return null } // don't display if there are no students
			
			var classItems = []
			var studentItems = []

			var fakeStudentList = {id: 0, name: 'Unassigned Students'}

			classItems.push(
				<RosterStudentList key={"sl-" + 0}
					slIndex={0}
					fetchStudents={this.props.fetchStudents}
					toggleFormStatus={this.toggleEditSLForm}
					openSectionClass={this.state.expandedStudentListFormClass}
					expanded={this.slExpanded(0)}
					formExpanded={this.slFormExpanded(0)}
					handleExpandStudentListSection={this.handleExpandStudentListSection}
					studentList={fakeStudentList} />
			);

			$wr.sortByName(students, $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST).forEach(student => {
				var studentList = this.unassignedSLLookup(student)
				studentItems.push(
					<RosterUnAssignedStudent key={"sl-" + 0 + "-student-" + student.id}
						student={student}
						toggleSelected={() => this.toggleStudentID(student.id)}
						onUpdateArchivedStudent={() => this.onUpdateArchivedStudent() }
						studentList={studentList} />
				);
			})

			var collapsedClass = _.include(this.state.expandedStudentListSections, 0) ? "expanded" : "collapsed"
			var classSection = (
				<div className={"classSectionContainer " + collapsedClass} key={'classSectionContainer-' + 0}>
					{classItems}
					<div className="studentSectionContainer unassignedStudent">
						{studentItems}
					</div>
				</div>
			)
			items.push(classSection)
		}
		return items;
	}

	render() {
		if (this.checkIsPendingSchool()) {
			var schoolInfoModal = (
				<SchoolInfoModal onClose={() => this.props.fetchStudentLists()} />
			);
		}

		var items = [];

		items.push(this.renderOverallLine());

		if (this.props.loading) {
			items.push(<Spinner key='spinner' scale={1} className="demoBtnSpinner" />)
		} else if (!this.props.studentLists.length) {
			items.push(this.renderEmptySection())
		} else {
			_.flatten(items.push(this.renderStudentsAndStudentLists()))
		}

		return (
			<div className="container rosterContent">
				{this.renderOverdrawnMessage()}
				<Glyphicon className="filterIcon" icon="filter" />
				<OrgDropdown dropdownDisplay="link"
					selectedIdentifier={this.props.orgIdentifier}
					onSelect={this.props.changeOrgIdentifier} />
				{items}
				{this.renderUnassignedStudents()}
				{this.renderToolbar()}
				{schoolInfoModal}
			</div>
		);
	}

	componentDidMount() {
		$(document).on('task-finished-loading', this.handleRosterUpdate)

		// this.props.fetchStudents();
		// this.props.fetchStudentLists();
		this.props.getCleverUser()
		this.updateArchivedStudentLists()
		this.props.populateData()

		if ($wr.getURLParameterByName('add_student_method') == 'clever') {
			this.addStudentsModal.current.show();
		}
	}

	componentWillUnmount() {
		$(document).off('task-finished-loading', this.handleRosterUpdate)
	}

}

RosterContent.WrappedComponent.propTypes = PageStrictPropTypes({
	// From above
	orgIdentifier: PropTypes.string.isRequired,
	changeOrgIdentifier: PropTypes.func.isRequired,

	// @connect data
	getStudents: PropTypes.func,
	studentLists: PropTypes.array,
	currentAdmin: PropTypes.object,
	loading: PropTypes.bool,

	// @connect handlers
	populateData: PropTypes.func,
	fetchStudents: PropTypes.func,
	fetchStudentLists: PropTypes.func,
	fetchArchivedStudentLists: PropTypes.func,
	addDemoStudent: PropTypes.func,
	archiveStudentList: PropTypes.func,
	destroyStudents: PropTypes.func,
	getCleverUser: PropTypes.func,
	updateStudentList: PropTypes.func
});

module.exports = RosterContent;


// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterContent.js